module.exports = __webpack_public_path__ + "media/images/marble-page-bg-1-fda01a8520448af0c1ce2ee7f051c086.jpg";